import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Control, Errors, Form } from 'forms/rrf';
import { Col, Row } from 'react-bootstrap';
import LayoutContainer from '../../layout/layout-container/index';
import ErrorMessages from '../../login/error-messages';
import UserFirstNameInput from '../../common/form/user/user-first-name-input';
import UserLastNameInput from '../../common/form/user/user-last-name-input';
import ArrowButton from '../../common/button-arrow';
import RequiredInput from '../../common/form/elements/required-input';
import BsCheckbox from '../../common/form/elements/bs-checkbox';

const model = 'deep.personal_rewards';

class UserDetailsForm extends Component {
  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  render() {
    const { formValid, acceptedTerms, onSubmit } = this.props;

    return (
      <LayoutContainer>
        <Form
          className="user-details-form"
          model={model}
          onSubmit={onSubmit}
        >
          <Errors className="errors" component={ErrorMessages} model={model} />
          <Row>
            <Col lg={12}>
              <UserFirstNameInput/>
              <UserLastNameInput/>
              <RequiredInput
                label="Email address"
                model=".email"
                placeholder="email"
              />
              <Control.checkbox component={BsCheckbox} model=".accept_terms">
                I agree to the prepaid card
                {' '}
                <Link target="_blank" to="/content-pages/ppc-terms-conditions">
                  terms and conditions
                </Link>
                .
              </Control.checkbox>
              <Errors
                className="errors"
                model='.accept_terms'
                show={{
                  touched: true,
                  focus: false
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <ArrowButton
                arrow={false}
                className="float-end"
                color="red"
                disabled={!formValid || !acceptedTerms}
              >
                Opt in
              </ArrowButton>
            </Col>
          </Row>
        </Form>
      </LayoutContainer>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.personal_rewards.$form.valid,
  acceptedTerms: state.deep.personal_rewards.accept_terms,
});

export default connect(mapStateToProps)(UserDetailsForm);
